<ion-spinner name="crescent" class="spinner"></ion-spinner>
